<template>
  <v-dialog
    v-model="show"
    max-width="700"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Карта {{ item ? item.uid : '' }}</span>
      </v-card-title>
      <v-card-text v-if="item">
        <div
          v-for="block in blocks"
          :key="block.title"
          class="mb-4"
        >
          <div class="text-subtitle-1 font-weight-bold mb-1">
            {{ block.title }}
          </div>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr
                  v-for="row in block.rows"
                  :key="row[0]"
                >
                  <td style="width: 40%">
                    {{ row[0] }}
                  </td>
                  <td>{{ row[1] }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          @click="show = false"
        >
          <span class="mx-4">Закрыть</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SkudCardService } from '@/views/skud/shared/services/skud-card-service'

export default {
  name: 'SkudCardCredentialDialog',
  data () {
    return {
      svc: null,
      show: false,
      item: null
    }
  },
  computed: {
    // Блоки с пропуском пустых значений (null/undefined/'' не рисуем).
    blocks () {
      const x = this.item
      if (!x) return []
      const row = (name, v) => (v === null || v === undefined || v === '') ? null : [name, v]
      const pack = (title, rows) => {
        const r = rows.filter(a => a !== null)
        return r.length ? { title: title, rows: r } : null
      }
      const subject = x.subject || {}
      return [
        pack('Карта', [
          row('UID', x.uid),
          row('Тип', x.kind_text),
          row('Эмитент', x.issuer_text),
          row('Состояние', x.state_text),
          row('Заменена', x.replaced_at),
          row('Принимается до', x.replaced_until)
        ]),
        pack('Субъект', [
          row('Субъект', subject.subject_ref),
          row('Роль', subject.role_code),
          row('Группа', subject.group_ref)
        ])
      ].filter(a => a !== null)
    }
  },
  mounted () {
    this.svc = new SkudCardService()
  },
  methods: {
    async open (credentialId, placeId) {
      if (!placeId) {
        this.$store.commit('snackbar', 'Неизвестное место карты')
        return
      }
      const res = await this.svc.getCredential(placeId, credentialId)
      if (!res) {
        this.$store.commit('snackbar', this.svc.error || 'Ошибка при получении данных')
        return
      }
      this.item = res
      this.show = true
    }
  }
}
</script>
